/* eslint-disable import/prefer-default-export */
import BaseFeature from '@appblocks/codegeneration/BaseFeature';
import ProjectConfiguration from '@appblocks/codegeneration/ProjectConfiguration';
import {
    CodeBlock,
    BlockType,
    SettingType,
    Define,
    ValidationMessageType,
    ValidationMessage,
    SettingState,
    Setting,
    TibboDataType,
} from '@appblocks/codegeneration/types';
import BaseNode from '@appblocks/codegeneration/Nodes/BaseNode';
import NodePort from '@appblocks/codegeneration/Nodes/NodePort';
import NodeParameter from '@appblocks/codegeneration/Nodes/NodeParameter';


export const getCodeBlocks = (feature: BaseFeature): CodeBlock[] => {
    const blocks: Array<CodeBlock> = [];

    blocks.push({
        location: 'on_sys_timer',
        blockType: BlockType.CODE,
        template: `
    mqtt_proc_timer()`,
    });

    blocks.push({
        location: 'on_sock_data_arrival',
        blockType: BlockType.CODE,
        template: '\tmqtt_proc_data()',
    });

    blocks.push({
        location: 'callback_dns_answer_acquired',
        blockType: BlockType.CODE,
        template: `
    mqtt_dns_answer_acquired(return_type, return_string)`,
    });


    blocks.push({
        location: 'on_sock_event',
        blockType: BlockType.CODE,
        template: '\tmqtt_sock_event(newstate, newstatesimple)',
    });

    blocks.push({
        location: 'DEVICE_TBS_DIMS',
        blockType: BlockType.CODE,
        template: `
dim mqtt_connect_lost as no_yes=NO
`,
    });

    blocks.push({
        location: 'DEVICE_TBS',
        blockType: BlockType.LOCATION,
        id: 'callback_mqtt_connect_ok',
        template: `
sub callback_mqtt_connect_ok()
    pat.play("G~",PL_PAT_CANINT)
    '****callback_mqtt_connect_ok****'
end sub
        `,
    });

    blocks.push({
        location: 'DEVICE_TBS',
        blockType: BlockType.LOCATION,
        id: 'callback_mqtt_connect_lost',
        template: `
sub callback_mqtt_connect_lost()
    '****callback_mqtt_connect_lost****'
    pat.play("-",PL_PAT_CANINT)
    mqtt_connect_lost=YES
end sub
        `,
    });

    const mqtt_notif_callback = `
function mqtt_topic_match(subscribed_topic as string, current_topic as string) as boolean
    mqtt_topic_match=false
    if subscribed_topic = current_topic then
        mqtt_topic_match=true
    else
        dim index as byte=instr(1,subscribed_topic,"/",1)
        dim start as byte=1
        while index<>0
            mqtt_topic_match=true
            dim section as string=mid(subscribed_topic,start,index-start)
            if section="#" then
                ' multi level wildcard
                exit while
            end if
            if section="+" OR section=mid(current_topic,start,index-start) then
                if index<=len(subscribed_topic) then
                    start=index+1
                    index=instr(start,subscribed_topic,"/",1)
                    if index=0 then 
                        index=len(subscribed_topic)+1
                    end if
                else
                    exit while
                end if
            else
                mqtt_topic_match=false
                exit while
            end if
        wend
    end if
end function

sub callback_mqtt_notif(byref topic as string,byref data as string,remaining_bytes as dword)
    '****callback_mqtt_notif****'
end sub`;
    blocks.push({
        location: 'DEVICE_TBS',
        blockType: BlockType.LOCATION,
        id: 'callback_mqtt_notif',
        template: mqtt_notif_callback,
    });
    blocks.push({
        location: 'DEVICE_TBS',
        blockType: BlockType.LOCATION,
        id: 'callback_mqtt_sub_ok',
        template: `
sub callback_mqtt_sub_ok()
    '****callback_mqtt_sub_ok****'
end sub
        `,
    });

    blocks.push({
        location: 'services_stop',
        blockType: BlockType.CODE,
        template: `
mqtt_stop()`,
    });

    return blocks;
};
